import { PropsWithChildren } from "react"

import { PostHogProvider } from "posthog-react-native"

import { AUTH_HOSTS } from "src/config/config.base"
import { useAuth } from "src/context/AuthContext"

// A type to ensure POSTHOG_KEYS includes all HOSTS keys plus DEFAULT
// Ensure we support all known auth host environments plus a DEFAULT
type PostHogKeysType = {
  [K in keyof typeof AUTH_HOSTS | "DEFAULT"]: string
}

const POSTHOG_KEYS: PostHogKeysType = {
  DEFAULT: "phc_pb0a3jGNLARCL7eKZEfO6AOkUQ159Np70pcbptBOchz",
  PROD: "phc_z37hS4RU2dYXB8If0ffmqvOLfG0KwzjbIGG2R2FUedJ",
  PREPROD: "phc_hGGPgXAUjL6vsZjSlfinC1Ba0eaEiWQbSCEw5271KU1",
  DEV: "phc_2u3ofzmAEK3GVu0gnBg5TIKPAyeHD9yPxfxHAL2QExH",
  DEV2: "phc_fSbsCHu7yOna6oJoLJAFcUG06vyhCvqzFdrixuWmd62",
  INTRL: "phc_pyZE3NTSXoh2uBUP4pMVQCd6fpO83lb0F9N1extFPIo",
  STAG: "phc_LtCbdapvUL0S3DVxJSV2XeVYYtYr7zJOXlB1poXkE51",
  TEST: "phc_7jeMvrb3mMzrRRF8U1fMf75ur5K9aMeZWPuvfcL60el",
} as const

const getEnvironmentKeyFromAuthHost = (authHostname: string): keyof PostHogKeysType => {
  const match = Object.entries(AUTH_HOSTS).find(([, host]) => host === authHostname)
  return (match?.[0] ?? "DEFAULT") as keyof PostHogKeysType
}

function PostHogWrapper({ children }: PropsWithChildren) {
  const { authHost } = useAuth()
  const envKey = getEnvironmentKeyFromAuthHost(authHost)
  const apiKey = POSTHOG_KEYS[envKey] ?? POSTHOG_KEYS.DEFAULT

  return (
    <PostHogProvider apiKey={apiKey} options={{ host: "https://us.posthog.com" }}>
      {children}
    </PostHogProvider>
  )
}

export default PostHogWrapper
